<template>
<div style="height: 100%;">
    <div id="main" v-show="!rotaAninhada">
        <container-loader
            v-if="isLoading && !$store.getters.isLoading"
        />
        <div class="page">
            <div class="motivoatendimento vertical-flow">
                <div class="listing-header">
                    <!-- TÍTULO E BREADCRUMB -->
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t("motivo-atendimento") }}
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{
                                        $t("vendas")
                                    }}</a>
                                </li>
                                <li>
                                    <a class="a-inativo">{{
                                        $t("crm")
                                    }}</a>
                                </li>
                                <li>
                                    <a aria-current="page">{{
                                        $t("motivo-atendimento")
                                    }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>

                    <!-- BOTÃ•ES -->
                    <div class="header-buttons">
                        <button
                            v-if="
                                permissao.create && !motivoatendimentoIntegracao
                            "
                            class="save-btn"
                            type="button"
                            tag="button"
                            @click="
                                $router.push({
                                    name: 'ven-motivo-atendimento-new',
                                })
                            "
                        >
                            {{ $t("adicionar") }}
                        </button>
                    </div>
                </div>

                <!-- PESQUISA E FILTROS -->
                <div class="columns is-multiline">
                    <div class="column is-three-quarters">
                        <search-bar
                            :onSearch="debouncedOnSearch"
                            tooltipLabel="msg-busca-codigo-descricao"
                        />
                    </div>

                    <!-- SITUACAO -->
                    <div class="situacao-select column is-one-quarter">
                        <label v-text="$t('situacao')" />
                        <v-select
                            ref="situacaoInput"
                            class="is-100"
                            label="label"
                            :options="situacoes"
                            @input="updateSituacao"
                            v-model="situacao"
                        >
                            <template slot="option" slot-scope="option">
                                {{ $t(option.label) }}
                            </template>
                            <template
                                slot="selected-option"
                                slot-scope="option"
                            >
                                {{ $t(option.label) }}
                            </template>
                            <template slot="no-options">{{
                                $t("sem-resultados")
                            }}</template>
                        </v-select>
                    </div>
                </div>

                <!-- LISTAGEM -->
                <div class="motivoatendimento-table registry-wrapper">
                    <empty-table-message v-if="isEmpty" />
                    <b-table
                        v-else
                        class="data-table"
                        :data="allmotivoatendimentos"
                        :mobile-cards="false"
                        @sort="sortTable"
                        backend-sorting
                    >
                        <b-table-column
                            v-for="(f, i) in fields"
                            class="td-center"
                            :key="i"
                            :field="f.key"
                            :label="f.key != 'excluir' ? $t(f.key) : ''"
                            :width="f.width"
                            :sortable="f.sortable"
                            v-slot="props"
                        >
                            <div v-if="f.key == 'excluir'">
                                <template
                                    v-if="
                                        permissao.update &&
                                        !motivoatendimentoIntegracao
                                    "
                                >
                                    <b-button
                                        v-if="props.row.situacao"
                                        type="is-danger"
                                        icon-right="delete"
                                        @click="confirmExclusion(props.row)"
                                        v-tippy 
                                        :title="$t('desativar')"
                                    />

                                    <b-button
                                        v-else
                                        type="is-success"
                                        icon-right="check"
                                        @click="
                                            confirmReactivation(props.row)
                                        "
                                        v-tippy 
                                        :title="$t('reativar')"
                                    />
                                </template>
                            </div>
                            <div v-else-if="f.key == 'descricao'">
                                <router-link
                                    :to="{
                                        name: 'ven-motivo-atendimento-edit',
                                        params: { id: props.row.id },
                                    }"
                                >
                                    <pre>{{ props.row[f.key] }}</pre>
                                </router-link>
                            </div>
                            <div v-else-if="f.key == 'situacao'">
                                <b-tag
                                    class="table-tag table-tag-full-width"
                                    v-if="props.row[f.key] == 1"
                                    type="is-success"
                                    size="is-medium"
                                    >{{ $t("ativo") }}</b-tag
                                >
                                <b-tag
                                    class="table-tag table-tag-full-width"
                                    v-else
                                    type="is-danger"
                                    size="is-medium"
                                    >{{ $t("inativo") }}</b-tag
                                >
                            </div>
                            <div v-else>
                                {{ props.row[f.key] }}
                            </div>
                        </b-table-column>
                    </b-table>
                    <PaginationViewer
                        class="mb-0"
                        :resetPagination="pagination.resetPagination"
                        :totalItems="pagination.totalRows"
                        :perPageOptions="pagination.perPageOptions"
                        :optionStarted="pagination.optionStarted"
                        @change="updatePagination"
                    />
                </div>
            </div>
        </div>
        </div>
        <router-view />
    </div>
</template>

<script>
import MotivoAtendimentoService from "@/services/MotivoAtendimentoService";
import ContainerLoader from "@/components/content/loader/ContainerLoader";

export default {
    beforeRouteUpdate(to, from, next) {
        if (['ven-motivo-atendimento-new', 'ven-motivo-atendimento-edit'].includes(to.name)) {
            this.rotaAninhada = true;
            next();
        } else {
            this.rotaAninhada = false;
            this.carregarDados();
            next();
        }
    },
    components: {
        ContainerLoader,
    },
    data() {
        return {
            motivoatendimentoIntegracao:
                this.$store.state.user.tabelasERPWebServer.includes(
                    "CRM_MOTIVO_ATENDIMENTO"
                ),
            allmotivoatendimentos: [],
            service: new MotivoAtendimentoService(
                this.$http,
                this.$router
            ),
            fields: [
                { key: "codigo", width: '7.5%', sortable: true },
                { key: "descricao", width: null, sortable: true },
                { key: "situacao", width: 80, sortable: true, sortFn: null },
                { key: "excluir", width: 70, sortable: false },
            ],
            situacoes: [
                { label: "todos", id: 2 },
                { label: "ativo", id: 1 },
                { label: "inativo", id: 0 },
            ],
            situacao: { label: "todos", id: 2 },
            deleteThis: null,
            isLoading: false,
            isEmpty: false,
            situacaoAcao: null,
            debouncedOnSearch: null,
            column: "descricao",
            order: "asc",
            permissao: {},
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
        };
    },
    created() {
        if (['ven-motivo-atendimento-new', 'ven-motivo-atendimento-edit'].includes(this.$route.name)) {
            this.rotaAninhada = true;
        } else {
            this.rotaAninhada = false;
        }

        // Seleciona o valor na posiÃ§Ã£o do array de opÃ§Ãµes de paginaÃ§Ã£o
        this.pagination.perPage =
            this.pagination.perPageOptions[this.pagination.optionStarted];
        this.permissao = this.hasPermissionAccess(
            "vendas",
            "crm",
            "ven-motivo-atendimento"
        );

        !this.permissao.read &&
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "motivo-atendimento" },
            });

        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        this.carregarDados();
    },
    methods: {
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.carregarDados();
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;
            this.isLoading = true;
            this.service
                .findAll(
                    this.column,
                    this.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.situacao.id,
                    this.queryFilter
                )
                .then(this.mapItems)
                .then((value) => {
                    this.allmotivoatendimentos = value;
                    this.isEmpty =
                        this.allmotivoatendimentos.length <= 0;
                })
                .catch((e) => {
                    console.error(
                        "Erro ao carregar motivos de atendimento agricola.",
                        e
                    );
                    this.isEmpty = true;
                    this.$root.showMessage("error", "msg-erro-dados-geral");
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        mapItems(body) {
            if (body) {
                if (body.content) {
                    this.pagination.totalRows = body.totalElements;
                    let motivoAtendimentoList = body.content.map((motivo) => {
                        return {
                            id: motivo.idMotivoAtendimento,
                            codigo: motivo.idMotivoAtendimentoErp,
                            descricao: motivo.descricao,
                            situacao: motivo.situacao,
                        };
                    });
                    return motivoAtendimentoList;
                }
            } else {
                return [];
            }
        },
        confirmExclusion(item) {
            this.deleteThis = item;
            this.situacaoAcao = 0;

            this.$root.confirm({
                message: this.$t("msg-confirmacao-desativacao-n", { n: item.descricao }),
                onConfirm: this.updateSituacaoRegistro,
                onCancel: (_) => {
                    this.deleteThis = null;
                },
            });
        },
        confirmReactivation(item) {
            this.deleteThis = item;
            this.situacaoAcao = 1;
            this.$root.confirm({
                message: this.$t("msg-confirmacao-reativacao-n", { n: item.descricao }),
                onConfirm: this.updateSituacaoRegistro,
                onCancel: (_) => {
                    this.deleteThis = null;
                },
            });
        },
        updateSituacaoRegistro() {
            this.isLoading = true;
            let motivoatendimento = {
                idMotivoAtendimento: this.deleteThis.id,
                situacao: this.situacaoAcao,
            };
            this.service
                .updateSituacao(motivoatendimento)
                .then((r) => {
                    if (r.status == 200) {
                        let tempSuccess =
                        this.$t(
                            r.content.situacao == 1
                                ? "msg-sucesso-ao-reativar-n"
                                : "msg-sucesso-ao-desativar-n", 
                            { n: this.$t("motivo-atendimento") }
                        );
                        this.$root.showMessage("success", tempSuccess, true, false);
                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage(
                            "error",
                            "msg-problema-realizar-acao"
                        );
                    }
                })
                .catch((e) => {
                    console.error("Erro ao remover propriedade.", e);
                    this.$root.showMessage(
                        "error",
                        "msg-problema-realizar-acao"
                    );
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados();
        },
        updateSituacao(t) {
            if (t) {
                this.situacao = t;
            } else {
                this.situacao = this.situacoes[0];
            }
            this.carregarDados();
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;
}

.page {
    position: relative;
    padding-left: 0;

    .title-breadcrumb {
        padding-bottom: 10px;
    }
    .situacao-select div,
    .produtivo-select div {
        height: 40px;
    }
}
</style>
